import {Component} from "@angular/core";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {Observable} from "rxjs";

export interface PrintPreviewHelperDialogResultModel {
  close: () => void;
  retry: boolean;
}

@Component({
  templateUrl: "./print-preview-helper-dialog.template.pug",
})
export class PrintPreviewHelperDialogComponent extends DialogComponent<{}, PrintPreviewHelperDialogResultModel> {
  static show(dialogService: DialogService): Observable<PrintPreviewHelperDialogResultModel> {
    return dialogService.addDialog(PrintPreviewHelperDialogComponent, {}, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  constructor(protected dialogService: DialogService) {
    super(dialogService);
    this.result = {close: () => { this.close(); }, retry: false};
  }

  retry() {
    this.subscriber.next({close: () => { this.close(); }, retry: true});
  }
}
